import httpRequestsPaths from "@helpers/httpRequestsPaths/httpRequestsPaths";
import httpRequest from "../httpRequest";
import endpointsPaths from "../endpointsPaths/endpointsPaths";

export const retrieveCheckoutSessionStripe = (checkSessionId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: temas } = await httpRequest({
        url: `${endpointsPaths.suscripciones}/${httpRequestsPaths.suscripciones.retrieveCheckoutSession}`,
        method: "POST",
        body: JSON.stringify(checkSessionId),
      });

      resolve(temas);
    } catch (error) {
      // console.log("Error el obtener los temas: ", error);

      reject(error);
    }
  });
};


export const actualizarSuscripcionRegistro = (infoSuscripcion) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: temas } = await httpRequest({
        url: `${endpointsPaths.suscripciones}/${httpRequestsPaths.suscripciones.actualizarInfoSuscripcion}`,
        method: "POST",
        body: JSON.stringify(infoSuscripcion),
      });

      resolve(temas);
    } catch (error) {
      // console.log("Error el obtener los temas: ", error);

      reject(error);
    }
  });
};


export const getCustomerPortal = (infoSuscripcion) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data: temas } = await httpRequest({
        url: `${endpointsPaths.suscripciones}/${httpRequestsPaths.suscripciones.createPortalSession}`,
        method: "POST",
        body: JSON.stringify(infoSuscripcion),
      });

      resolve(temas);
    } catch (error) {
      // console.log("Error el obtener los temas: ", error);

      reject(error);
    }
  });
};